import {Component, computed, effect, inject, OnDestroy} from '@angular/core';
import {OverlayBadge} from 'primeng/overlaybadge';
import {Popover} from 'primeng/popover';
import {Button} from 'primeng/button';
import {DatePipe} from '@angular/common';
import {Tooltip} from 'primeng/tooltip';
import {NotificationFilterType, NotificationsContext} from './notification.context';
import {NotificationsFacade} from './notification.facade';
import {SelectButton} from 'primeng/selectbutton';
import {AppNotification} from './notification.model';
import {UserProfileStore} from '../../../core/auth/stores/user-profile.store';
import {SessionStore} from '../../../core/auth/stores/session.store';

@Component({
	selector: 'app-notification-center',
	imports: [OverlayBadge, Popover, Button, DatePipe, Tooltip, SelectButton],
	standalone: true,
	templateUrl: './notification-center.component.html',
	styles: ``
})
export class NotificationCenterComponent implements OnDestroy {
	private ctx = inject(NotificationsContext)
	private facade = inject(NotificationsFacade)
	private session = inject(SessionStore)
	private profileUser = inject(UserProfileStore)
	private connectedToken: string | null = null
	private loadedNotificationsForUserId: string | null = null

	readonly notifications = this.ctx.notifications
	readonly notificationTypes: { label: string; value: NotificationFilterType }[] = [
		{ label: 'Non lette', value: 'UNREADED' },
		{ label: 'Lette', value: 'READED' }
	]

	notificationBadgeValue = computed( () => this.notifications().filter(n => !n.read).length )
	userProfile = this.profileUser.currentUser

	constructor() {
		effect(() => {
			const userId = this.userProfile()?.id;

			if (!userId || userId === this.loadedNotificationsForUserId) return;

			this.loadedNotificationsForUserId = userId;
			this.facade.getAllNotifications(userId);
		});

		effect(() => {
			const token = this.session.authToken();

			if (!token) {
				this.connectedToken = null;
				this.facade.disconnectWebsocket();
				return;
			}

			if (token === this.connectedToken) return;

			this.connectedToken = token;
			this.facade.connectWebsocket(token);
		});
	}

	filterNotificationType(e: { value?: NotificationFilterType }) {
		this.ctx.notificationFilter.set(e.value ?? 'ALL')
	}

	setNotificationReaded(n: AppNotification) {
		this.facade.markAsReaded(n.id)
	}

	setAllNotificationAsReaded() {
		this.facade.markAllAsRead()
	}

	ngOnDestroy() {
		this.facade.disconnectWebsocket();
	}
}
